export function deleteSpaces(str: string) {
    return str.replace(/\s/g, "");
}

export function extractNumber(str: string) :number{
    return Number(str.replace(/\D/g, "")); // Supprime tous les caractères non numériques
}
